export default __webpack_public_path__ + "static/media/delete.f7fa1e70.png";